import { Record } from 'immutable';

export const ACCOUNTS_VALUE_CHANGES_REDUCER_KEY = 'accountsValueChangesStore';

export const mkAccountsValueChanges = Record({
  columns: undefined,
  rowType: undefined,
  rows: undefined,
});
